import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anon) {
  // Don't crash the bundle in dev if env is missing — surface a clear console hint.
  // The app will still render, just with empty data.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env and fill it in.'
  )
}

export const supabase = createClient(url ?? 'http://localhost', anon ?? 'public-anon')
